export default __webpack_public_path__ + "img/rose.asset.4e826ff8.png";